import { Component, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
  template: '',
})
// eslint-disable-next-line @angular-eslint/component-class-suffix
export class Destructible implements OnDestroy {
  destroy$: Subject<boolean> = new Subject<boolean>();
  destroyed = false;

  ngOnDestroy(): void {
    this.destroyed = true;
    this.destroy$.next(true);
    this.destroy$.complete();
  }
}
